module.exports = __webpack_public_path__ + "static/media/SM-MT-3.93ea6a6b.mp3";